import { VersionFragment, VersionListItemFragment } from 'gqlTypes'

export type DownloadProps =
  | { isAvailable: true; url: string }
  | { isAvailable: false; url?: string }

export const getDownloadProps = (
  version: VersionFragment | VersionListItemFragment | null
): DownloadProps => {
  const isAvailable = !!version?.document?.downloadAvailable

  if (isAvailable && version?.document?.url) {
    return { isAvailable: true, url: version.document.url }
  }
  return { isAvailable: false, url: version?.document?.url || undefined }
}
